//
import * as React from 'react'
import date_module from '../modules/date'

const Date = React.memo(function Date(props) {
    const { children, format, options, className } = props
    const { date = children } = props
    const date_label = React.useMemo(() => date_module.format(date, format, options), [date, format, options])
    return (
        <time dateTime={date + ''} className={className}>
            {date_label || <span>&#x200b;</span>}
        </time>
    )
})

export default Date
